import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import 'firebase/compat/analytics'

Vue.config.productionTip = true

import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import App from './App.vue'
import router from './router'
import VueApexCharts from "vue-apexcharts";

import store from './store/store'

import FirebasePlugin from './plugins/FirebasePlugin'
import firebaseConfig from './store/credentials/firebase'

import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";

import FlowyPlugin from "@hipsjs/flowy-vue";
import "@hipsjs/flowy-vue/dist/lib/flowy-vue.css";

import { library } from '@fortawesome/fontawesome-svg-core';
// internal icons
import { faCheck, faCheckCircle, faInfoCircle, faExclamationTriangle, faExclamationCircle,
    faArrowUp, faAngleRight, faAngleLeft, faAngleDown,
    faEye, faEyeSlash, faCaretDown, faCaretUp, faUpload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(faCheck, faCheckCircle, faInfoCircle, faExclamationTriangle, faExclamationCircle,
    faArrowUp, faAngleRight, faAngleLeft, faAngleDown,
    faEye, faEyeSlash, faCaretDown, faCaretUp, faUpload);
Vue.component('vue-fontawesome', FontAwesomeIcon);


Vue.use(FlowyPlugin);

import DemoNode from '@/components/WorkflowNodes.vue'
import DemoBlock from '@/components/WorkflowBlocks.vue'

Vue.component('demo-block', DemoBlock)
Vue.component('demo-node', DemoNode)


import Buefy from 'buefy'
import 'buefy/dist/buefy.css'

import 'vue-good-table/dist/vue-good-table.css'
import 'vue3-markdown-it'


Vue.use(Buefy,{
  defaultIconComponent: 'vue-fontawesome',
  defaultIconPack: 'fa'
})

Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts);
//Vue.component("vue3-markdown-it", VueMarkdownIt)

Vue.use(VueAxios, axios)
Vue.use(VueAxios, { $api: axios })

import VueSidebarMenu from 'vue-sidebar-menu'
import 'vue-sidebar-menu/dist/vue-sidebar-menu.css'
Vue.use(VueSidebarMenu)

import '@/css/style.scss';

import VueConfetti from 'vue-confetti'

Vue.use(VueConfetti)

Sentry.init({
  App,
  dsn: "https://1a53d6079e7a4718acff509cbec8b265@o996803.ingest.sentry.io/5955314",
  integrations: [
    new Integrations.BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      tracingOrigins: ["localhost", "app.metatext.io", /^\//],
    }),
  ],
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 0.1,
  beforeSend(event, hint) {
    // Check if it is an exception, and if so, show the report dialog
    if (event.exception) {
      var name = "";
      var email = ""  
      
      if (!hint) {
        hint = ""
      }

      if (firebase.auth().currentUser) {
        name = firebase.auth().currentUser.displayName
        email = firebase.auth().currentUser.email
      }
    //   Sentry.showReportDialog({
    //     eventId: event.event_id, user: {
    //       name, email
    //     }
    //   });
    }
    return event;
  }
});

const env = process.env.VUE_APP_ENV_NAME
if (!env) {
  throw new Error('VUE_APP_ENV_NAME is not defined')
}
firebase.initializeApp(
  firebaseConfig[env]
);

firebase.analytics()

const auth = firebase.auth()
const unsubscribe = auth.onAuthStateChanged((user) => {
  unsubscribe()

  if (user) {
    Sentry.configureScope(scope => {
      scope.setUser({
        email: user.email,
        username: user.displayName,
        id: user.uid
      })
    })
  }

  Vue.use(FirebasePlugin)

  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
})

